import { ArrowUpRight } from "lucide-react";
import { useLanguage } from "@/hooks/use-language";
import tiegoLogo from "@/assets/tiego-logo-white.webp";

const Footer = () => {
  const { t, localePath } = useLanguage();

  return (
    <footer className="bg-navy-deep py-16 lg:py-20">
      <div className="container mx-auto px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16">
          {/* Brand */}
          <div className="lg:col-span-2">
            <div className="flex items-center gap-3 mb-6">
              <img loading="lazy" decoding="async"
                src={tiegoLogo}
                alt="Tiego"
                width={280}
                height={178}
                className="h-12 w-auto"
              />
            </div>
            <p className="text-white/50 text-sm max-w-md leading-relaxed mb-6">
              {t(
                "Specialister inom finansiell systemstöd. Vi förenklar koncernredovisning och leasinghantering med smarta lösningar enligt K3, IFRS och RKR R5.",
                "Specialists in financial system support. We simplify group accounting and lease management with smart solutions according to K3, IFRS and RKR R5."
              )}
            </p>
            <div className="text-white/50 text-sm space-y-1 mb-6">
              <p>Sveavägen 68</p>
              <p>111 34 Stockholm</p>
              <a href="tel:+46812136801" className="block hover:text-white transition-colors">+46 8 1213 68 01</a>
            </div>
            <div className="flex gap-4">
              <a href="https://se.linkedin.com/company/tiego-ab" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn" className="w-10 h-10 rounded-xl bg-white/5 hover:bg-white/10 flex items-center justify-center transition-colors group">
                <svg className="w-5 h-5 text-white/50 group-hover:text-white transition-colors" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z"/>
                </svg>
              </a>
            </div>
          </div>

          {/* Systems */}
          <div>
            <h3 className="text-white font-semibold mb-6">{t("Våra system", "Our Systems")}</h3>
            <ul className="space-y-4">
              <li>
                <a href={localePath("/tga")} className="text-white/50 hover:text-white text-sm transition-colors flex items-center gap-2 group">
                  {t("TGA – Koncernredovisning", "TGA – Group Accounting")}
                  <ArrowUpRight className="w-3 h-3 opacity-0 group-hover:opacity-100 transition-opacity" />
                </a>
              </li>
              <li>
                <a href={localePath("/tle")} className="text-white/50 hover:text-white text-sm transition-colors flex items-center gap-2 group">
                  {t("TLE – Leasinghantering", "TLE – Lease Management")}
                  <ArrowUpRight className="w-3 h-3 opacity-0 group-hover:opacity-100 transition-opacity" />
                </a>
              </li>
            </ul>
          </div>

          {/* Resources */}
          <div>
            <h3 className="text-white font-semibold mb-6">{t("Resurser", "Resources")}</h3>
            <ul className="space-y-4">
              <li>
                <a href={localePath("/nyheter")} className="text-white/50 hover:text-white text-sm transition-colors flex items-center gap-2 group">
                  {t("Krönikor", "Articles")}
                  <ArrowUpRight className="w-3 h-3 opacity-0 group-hover:opacity-100 transition-opacity" />
                </a>
              </li>
              <li>
                <a href={localePath("/filmer")} className="text-white/50 hover:text-white text-sm transition-colors flex items-center gap-2 group">
                  {t("Filmer", "Videos")}
                  <ArrowUpRight className="w-3 h-3 opacity-0 group-hover:opacity-100 transition-opacity" />
                </a>
              </li>
              <li>
                <a href={localePath("/support")} className="text-white/50 hover:text-white text-sm transition-colors flex items-center gap-2 group">
                  {t("Kontakt", "Contact")}
                  <ArrowUpRight className="w-3 h-3 opacity-0 group-hover:opacity-100 transition-opacity" />
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-white/60 text-sm">
            © {new Date().getFullYear()} Tiego. {t("Alla rättigheter förbehållna.", "All rights reserved.")}
          </p>
          <div className="flex gap-8">
            <a href={localePath("/ai-policy")} className="text-white/60 hover:text-white text-sm transition-colors">
              AI Policy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
